import {Component, computed, inject, Signal, ChangeDetectionStrategy} from '@angular/core';
import {AppService} from '../../services/app/app.service';
import {AppQuery} from '../../queries/app.query';
import {IconsComponent} from '../dummy-components/icons.component';
import {SearchDashboardComponent} from '../search-dashboard/search-dashboard.component';
import {TranslateModule} from '@ngx-translate/core';
import {DarkModeEnabledPipe} from '../../pipes/dark-mode-enabled.pipe';
import {IconComponent} from '../icon/icon.component';
import {HeaderComponent} from '../header/header.component';
import {UrlParamsService} from '../../services/url-params/url-params.service';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-search-overview',
    templateUrl: './search-overview.component.html',
    styleUrls: [
        '../../pages/layout-tablet/layout-tablet.css',
        './search-overview.component.css'
    ],
    imports: [
        SearchDashboardComponent,
        TranslateModule,
        DarkModeEnabledPipe,
        IconComponent,
        HeaderComponent
    ]
})
export class SearchOverviewComponent extends IconsComponent {
    protected vaultId: Signal<string | undefined>;
    protected isGlobalSearchView: Signal<boolean>;
    protected historyBackAction: () => void;
    private readonly appService = inject(AppService);
    private readonly appQuery = inject(AppQuery);
    private readonly urlParamsService = inject(UrlParamsService);

    public constructor() {
        super();
        this.historyBackAction = (): void => {
            this.appService.hideSearchMenu();
        };
        this.isGlobalSearchView = toSignal(this.appQuery.isSearchTaskGlobalScope$, { initialValue: true });
        this.vaultId = computed(() => this.urlParamsService.getUrlParamsSignal()().vaultId);
    }
}
